<template>

    <div :style="'display: ' + rootElementDisplay + ';'">

        <slot :start-login-process="startLoginProcess" :working="working">

            <button @click.prevent="startLoginProcess" class="btn w-full flex items-center justify-center border border-gray-700 bg-freja text-white">
                <div>
                    <svg-icon v-show="working" url="fas/spinner" cursor="pointer" class="fa-spin w-5 h-5"></svg-icon>
                </div>
                <span v-bind:class="{'ml-2': working}" v-html="_('Sign_in_with_freja.button')"></span>
            </button>

        </slot>

    </div>

</template>

<script>

    import { mapGetters } from 'vuex'
    import axios from 'axios'

    export default {

        props: {
            rootElementDisplay : {
                required: false,
                type: String,
                default: 'block'
            }
        },

        data() {
            return {
                working: false,
                displayStyle: 'block'
            };
        },

        computed: {
            ...mapGetters('general', ['_', 'getPath']),
        },

        methods: {
            startLoginProcess() {
                this.working = true;

                axios({
                    method: 'get',
                    url: '/freja/get-authorization-url',
                }).then(({data}) => {
                    this.redirectBrowser(data.url);
                }).catch((error) => {
                    this.$emit('error', error);
                    this.working = false;
                });
            },

            redirectBrowser(url) {
                setTimeout(() => this.working = false, 3000);

                window.location.href = url;
            }
        }
    }

</script>
